import React from "react";
import axios from "axios";

import "./style.css";

import theme from "../../../Theme/theme";
import { toast } from "react-toastify";
import { alert } from "../../../common/Utils"
import { API_URL, ERROR_HANDLE } from "config/constants";

const SUCCESS = "Sent credits to user successfully!";
const FAILED = "Failed to send credits to user";
const ALERT = "Please enter a valid email and credit";

class WalletPricesScreen extends React.Component {

    initial_referrer_pre_workout_bonus = 0
    initial_referred_pre_workout_bonus = 0

    constructor(props) {
        super(props)
        this.state = {
            referred_pre_workout_bonus: 0,
            referrer_pre_workout_bonus: 0,
            email: "",
            credit: 0
        }
    }

    componentWillMount = () => {
        this.fetchBonus()
    }

    fetchBonus = () => {
        const access_token = localStorage.getItem("access_token");
        axios.get(`${API_URL}/admin/referral`, {
            headers: {
                "x-access-token": access_token
            },
        }).then(res => {
            let { referred_pre_workout_bonus, referrer_pre_workout_bonus } = res.data;
            this.initial_referrer_pre_workout_bonus = referrer_pre_workout_bonus;
            this.initial_referred_pre_workout_bonus = referred_pre_workout_bonus;
            referred_pre_workout_bonus && referrer_pre_workout_bonus && this.setState({
                referrer_pre_workout_bonus,
                referred_pre_workout_bonus
            })
        }).catch(error => {
            ERROR_HANDLE(error)
        });
    }

    updateBonus = () => {
        const access_token = localStorage.getItem("access_token");
        axios.post(`${API_URL}/admin/referral`, this.state, {
            headers: {
                "x-access-token": access_token
            },
        }).then(() => {
            this.save()
        }).catch(error => {
            ERROR_HANDLE(error);
        });
    }

    sendCredits = (amount, isDeduct = false) => {
        if (this.validCredits()) {
            const access_token = localStorage.getItem("access_token");
            const data = {
                email: this.state.email,
                amount: isDeduct ? -Math.abs(amount) : Math.abs(amount)
            }
            axios.post(`${API_URL}/wallet/load_wallet`, data, {
                headers: {
                    "x-access-token": access_token
                },
            }).then(response => {
                if (response.status == 200) toast.success(SUCCESS, { autoClose: 1500 });
                else toast.error(FAILED, { autoClose: 1500 });
                this.reset();
            }).catch(error => {
                ERROR_HANDLE(error);
            });
        } else alert(ALERT);
    }

    validCredits = () => {
        const amount = parseFloat(this.state.credit);
        const isValid = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(this.state.email);
        return !!amount && !isNaN(this.state.credit) && isValid;
    }

    getReferredPostWorkoutPrice = () => {
        return (10 - this.state.referred_pre_workout_bonus).toFixed(2)
    }

    getReferrerPostWorkoutPrice = () => {
        return (10 - this.state.referrer_pre_workout_bonus).toFixed(2)
    }

    incrementReferredPreWorkoutPrice = () => {
        var { referred_pre_workout_bonus } = this.state;
        if (referred_pre_workout_bonus < 10) {
            this.setState({
                referred_pre_workout_bonus: referred_pre_workout_bonus + 1,
                changed: true
            })
        }
    }

    decrementReferredPreWorkoutPrice = () => {
        var { referred_pre_workout_bonus } = this.state;
        if (referred_pre_workout_bonus > 0) {
            this.setState({
                referred_pre_workout_bonus: referred_pre_workout_bonus - 1,
                changed: true
            })
        }
    }

    incrementReferrerPreWorkoutPrice = () => {
        var { referrer_pre_workout_bonus } = this.state;
        if (referrer_pre_workout_bonus < 10) {
            this.setState({
                referrer_pre_workout_bonus: referrer_pre_workout_bonus + 1,
                changed: true
            })
        }
    }

    decrementReferrerPreWorkoutPrice = () => {
        var { referrer_pre_workout_bonus } = this.state;
        if (referrer_pre_workout_bonus > 0) {
            this.setState({
                referrer_pre_workout_bonus: referrer_pre_workout_bonus - 1,
                changed: true
            })
        }
    }

    cancel = () => {
        this.setState({
            referrer_pre_workout_bonus: this.initial_referrer_pre_workout_bonus,
            referred_pre_workout_bonus: this.initial_referred_pre_workout_bonus,
            changed: false
        })
    }

    save = () => {
        this.initial_referred_pre_workout_bonus = this.state.referred_pre_workout_bonus;
        this.initial_referrer_pre_workout_bonus = this.state.referrer_pre_workout_bonus;
        this.setState({
            changed: false
        })
    }

    reset = () => {
        this.setState({
            email: "",
            credit: 0,
        })
    }

    render() {
        return (
            <div className="root">

                <div className="background">
                    <p style={style.title}>{"Send Credits to User"}</p>
                    <div className="creditsContainer">
                        <div className="row-divider" />
                        <div className="row">
                            <div className="column-divider" />
                            <div className="column iron-cell" style={style.textBlack}>User Email</div>
                            <div className="column-divider" />

                            <div className="column-divider" />

                            <input
                                value={this.state.email}
                                style={style.input}
                                disableUnderline={true}
                                onChange={e => {
                                    this.setState({
                                        email: e.target.value
                                    });
                                }}
                            />
                            <div className="column-divider" />
                        </div>
                        <div className="row-divider" />
                        <div className="row">
                            <div className="column-divider" />
                            <div className="column iron-cell" style={style.textBlack}>Credit Amount</div>
                            <div className="column-divider" />
                            <div className="column">
                                <input
                                    value={this.state.credit}
                                    disableUnderline={true}
                                    style={style.input}
                                    onChange={e => {
                                        this.setState({
                                            credit: e.target.value
                                        });
                                    }}
                                />
                                <div className="column-divider" />
                            </div>
                        </div>
                        <div className="row-divider" />
                    </div>
                    <div className="send-button-container">
                        <div className="send-button" onClick={() => this.sendCredits(this.state.credit)}>Add</div>
                        <div className="send-button" style={{ marginLeft: 20 }} onClick={() => this.sendCredits(this.state.credit, true)}>Remove</div>
                    </div>

                </div>

                <div className="referralRoot">
                    {this.state.changed &&
                        <div className="button-container">
                            <div className="cancel-button" onClick={this.cancel}>Cancel</div>
                            <div className="save-button" onClick={this.updateBonus}>Save</div>
                        </div>
                    }
                    <div className="background">
                        <p style={style.title}>{"Friend Referral Split"}</p>
                        <div className="container">
                            <div className="row-divider" />
                            <div className="row">
                                <div className="column-divider" />
                                <div className="column blue-cell" style={style.rowTitles}>$</div>
                                <div className="column-divider" />
                                <div className="column grey-cell" style={style.columnTitles}>Pre-Workout Bonus</div>
                                <div className="column-divider" />
                                <div className="column grey-cell" style={style.columnTitles}>Post-Workout Bonus</div>
                                <div className="column-divider" />
                            </div>
                            <div className="row-divider" />
                            <div className="row">
                                <div className="column-divider" />
                                <div className="column grey-cell" style={style.rowTitles}>Referred</div>
                                <div className="column-divider" />
                                <div className="column">
                                    <div style={style.price}>{this.state.referred_pre_workout_bonus.toFixed(2)}</div>
                                    <div className="column-divider" />
                                    <div style={style.modifiersContainer}>
                                        <div className="button" style={style.modifiers} onClick={this.incrementReferredPreWorkoutPrice}>+</div>
                                        <div className="row-divider" />
                                        <div className="button" style={style.modifiers} onClick={this.decrementReferredPreWorkoutPrice}>-</div>
                                    </div>
                                </div>
                                <div className="column-divider" />
                                <div className="column">
                                    <div style={style.price}>{this.getReferredPostWorkoutPrice()}</div>
                                    <div className="column-divider" />
                                    <div style={style.modifiersContainer}>
                                        <div className="button" style={style.modifiers} onClick={this.decrementReferredPreWorkoutPrice}>+</div>
                                        <div className="row-divider" />
                                        <div className="button" style={style.modifiers} onClick={this.incrementReferredPreWorkoutPrice}>-</div>
                                    </div>
                                </div>
                                <div className="column-divider" />
                            </div>
                            <div className="row-divider" />
                            <div className="row">
                                <div className="column-divider" />
                                <div className="column grey-cell" style={style.rowTitles}>Referrer</div>
                                <div className="column-divider" />
                                <div className="column">
                                    <div style={style.price}>{this.state.referrer_pre_workout_bonus.toFixed(2)}</div>
                                    <div className="column-divider" />
                                    <div style={style.modifiersContainer}>
                                        <div className="button" style={style.modifiers} onClick={this.incrementReferrerPreWorkoutPrice}>+</div>
                                        <div className="row-divider" />
                                        <div className="button" style={style.modifiers} onClick={this.decrementReferrerPreWorkoutPrice}>-</div>
                                    </div>
                                </div>
                                <div className="column-divider" />
                                <div className="column">
                                    <div style={style.price}>{this.getReferrerPostWorkoutPrice()}</div>
                                    <div className="column-divider" />
                                    <div style={style.modifiersContainer}>
                                        <div className="button" style={style.modifiers} onClick={this.decrementReferrerPreWorkoutPrice}>+</div>
                                        <div className="row-divider" />
                                        <div className="button" style={style.modifiers} onClick={this.incrementReferrerPreWorkoutPrice}>-</div>
                                    </div>
                                </div>
                                <div className="column-divider" />
                            </div>
                            <div className="row-divider" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const style = {
    title: {
        fontSize: 20,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.thickGrey,
        textAlign: 'center'
    },

    rowTitles: {
        fontSize: 20,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.white,
        textAlign: 'center'
    },

    columnTitles: {
        fontSize: 16,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.white,
        textAlign: 'center'
    },

    price: {
        flex: 1,
        fontSize: 20,
        fontFamily: theme.font.avenirMediumOblique,
        color: theme.color.thickGrey,
        textAlign: 'center'
    },
    modifiersContainer: {
        alignSelf: 'center',
        flexDirection: 'column',
        alignItems: 'space-between'
    },
    modifiers: {
        backgroundColor: 'transparent',
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 5,
        paddingRight: 5,
        fontSize: 16,
        fontFamily: theme.font.avenirMediumOblique,
        color: theme.color.thickGrey,
    },
    input: {
        fontSize: 18,
        color: theme.color.primaryBlue,
        padding: 10,
        paddingLeft: 20,
        minWidth: 200,
        textAlign: "left",
        backgroundColor: theme.color.textLightWhite
    },
    textBlack: {
        fontSize: 18,
        padding: 15,
        fontFamily: theme.font.avenirMedium,
        color: theme.color.mediumGrey,
        textAlign: 'center'
    }
}

export default WalletPricesScreen